import { Component, OnInit } from '@angular/core';
import { StorageHelper } from '../helpers/StorageHelper';
import { Global } from '../classes/Global';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { TopsellerService } from '../topseller.service';
import { WishlistService } from '../wishlist.service';
import { Log } from '../helpers/Log';
import { BaseComponent } from '../classes/BaseComponent';
import { AiStructuredDataHelper } from '../helpers/AiStructuredDataHelper';

@Component({
  selector: 'app-vudu-movie-deals',
  templateUrl: './vudu-movie-deals.component.html',
  styleUrls: ['./vudu-movie-deals.component.scss'],
  providers: [ TopsellerService, WishlistService ]
})
export class VuduMovieDealsComponent extends BaseComponent implements OnInit {

  items;
  schema;

  constructor(
    private topSellerService: TopsellerService,
    private wishListService: WishlistService
  ) {
    super();
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.schema = AiStructuredDataHelper.buildDealsPageSchema(
      this.getString('vuduMovieDeals'),
      "https://www.cheapcharts.com/us/" + this.getString('vuduMovieDealsUrl'),
      Global.getCountry(),
      Global.VUDU,
      Global.BUYMOVIES
    );
    this.topSellerService.getTopSellersForStartPage(Global.getCountry(), 5).subscribe(res => {
      if (res && res["results"]) {
        this.items = res["results"][Global.VUDU];
      }
    }, err => {
      Log.getInstance().d(err);
    });
  }

  getLang(): string {
    return InternationalizationHelper.getTwoCharactersLanguage();
  }

  wishListClicked(item) {    
    const id = item.idInStore || item.itemID;
    this.wishListService.addItem(Global.getCountry(), Global.VUDU, Global.getMediaType(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), id).subscribe(res => {
      this.getShortWishList(Global.VUDU);
    }, err => {

    });
  }

  getShortWishList(store?: string) {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    store = store ? store : Global.getStore();
    if (sessionToken){
      this.wishListService.getShortWishlist(
        Global.getCountry(),
        store,
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
          shortWishlist[store] = res["results"];
          StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
        }
      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

}
